module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-solid-900.woff?87292218024ee1cab93406e228a0b7dd";